
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState([
      'shippingLeft',
      'calculatedShipping',
      'order',
      'freeShippingCouponLimit',
      'freeShippingCouponLeft',
    ]),
    ...mapGetters(['freeShipping']),

    noFreeShipping() {
      return !!(this.shippingLeft === 0 && this.order?.shipping?.shipping > 0);
    },

    progress() {
      if (this.shippingLeft === undefined || this.order?.shipping?.no_sale) {
        return undefined;
      }
      return this.freeShippingCouponLimit && this.freeShippingCouponLeft
        ? `${
            (Math.min(this.order.subtotal, this.freeShippingCouponLimit) /
              this.freeShippingCouponLimit) *
            100
          }%`
        : this.order?.shipping
        ? `${
            ((this.order.shipping.condition_limit - this.shippingLeft) /
              this.order.shipping.condition_limit) *
            100
          }%`
        : `${
            ((this.calculatedShipping.condition_limit - this.shippingLeft) /
              this.calculatedShipping.condition_limit) *
            100
          }%`;
    },
  },
};
